/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TokenRequestBuilderRequestsMetadata, type TokenRequestBuilder } from './token/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/maps
 */
export interface MapsRequestBuilder extends BaseRequestBuilder<MapsRequestBuilder> {
    /**
     * The token property
     */
    get token(): TokenRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MapsRequestBuilderUriTemplate = "{+baseurl}/api/maps";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MapsRequestBuilderNavigationMetadata: Record<Exclude<keyof MapsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    token: {
        requestsMetadata: TokenRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
